import { createApp } from 'vue';
// 顺序与原项目 app/layout.tsx 保持一致：先项目全局样式，再 LiveKit 官方样式
import './styles/globals.css';
import '@livekit/components-styles';
import '@livekit/components-styles/prefabs';
import App from './App.vue';
import router from './router';

createApp(App).use(router).mount('#app');
